import * as React from 'react';
export const ECSvg = React.forwardRef(function ECSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M1.994 0A1.998 1.998 0 0 0 0 1.998V6h16V1.998A1.997 1.997 0 0 0 14.006 0H1.994Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M15 6V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v4H0V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4h-1Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        d: 'M0 6h16v3H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M0 9v1.5c0 .828.667 1.5 1.505 1.5h12.99A1.5 1.5 0 0 0 16 10.5V9H0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#B1372F',
        fillRule: 'nonzero',
        d: 'M6.882 4.25H5.708a2.5 2.5 0 0 1 4.583 0H9.118a1.5 1.5 0 0 0-2.236 0Z',
      }),
      /*#__PURE__*/ React.createElement('circle', {
        cx: 8,
        cy: 6,
        r: 1.5,
        fill: '#FFF',
      }),
    ),
  );
});
ECSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var EC = {
  category: 'flag',
  colorable: false,
  name: 'EC',
  svg: ECSvg,
};
